import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { passwordResetAuthCodeQueryOptions } from "~/features/auth/api";
import { ResetPasswordTemplate } from "~/features/auth/ResetPasswordTemplate";

// BE が再設定メール/SMS に埋め込む URL 形式:
// {BASE}/reset-password?authCode=<9桁英数>&userId=<userId>
const resetPasswordSearchSchema = z.object({
  authCode: z.string().optional(),
  userId: z.string().optional(),
});

export const Route = createFileRoute("/reset-password")({
  validateSearch: resetPasswordSearchSchema,
  loaderDeps: ({ search }) => ({ authCode: search.authCode }),
  loader: ({ context: { queryClient }, deps }) => {
    if (!deps.authCode) return;
    return queryClient.ensureQueryData(
      passwordResetAuthCodeQueryOptions(deps.authCode),
    );
  },
  component: ResetPasswordTemplate,
});
